import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { JobApplyService } from "./service/job-apply.service";

@Component({
  selector: "app-job-apply",
  templateUrl: "./job-apply.component.html",
  styleUrls: ["./job-apply.component.css"]
})
export class JobApplyComponent implements OnInit {
  screeningQuestions: any[] = [];
  constructor(public modalRef: BsModalRef, private jobApplyService: JobApplyService) { }
  ngOnInit(): void { }
  close() {
    console.log('close');    
    this.modalRef?.hide();
    this.jobApplyService.discardJob();
  }
  applyForJob() {
    this.modalRef?.hide();
    this.jobApplyService.applyForJob(this.screeningQuestions, "");
  }
}
